/**
 * Strips accents and special characters from a string
 * @param {string} str - String to normalize
 * @returns {string} Normalized string with accents removed
 */
const normalizeString = str => {
  return str
    .normalize('NFD') // Decompose accented characters
    .replace(/[\u0300-\u036f]/g, '') // Remove accent marks
    .replace(/[^a-zA-Z0-9]/g, '') // Remove any remaining special characters
    .toLowerCase();
};

/**
 * Generates a default branch name using first two names and ISO date format
 * @param {Object} user - User object containing firstName, lastName, fullName, username, etc.
 * @returns {string} Default branch name in format: first-second/YYYY-MM-DD
 */
export const generateDefaultBranchName = user => {
  const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format

  // Get the full name from user object
  const fullName =
    user?.fullName || `${user?.firstName || ''} ${user?.lastName || ''}`.trim() || user?.username || 'dev';

  // Split by spaces and take first two names
  const nameParts = fullName.split(/\s+/).filter(part => part.length > 0);
  const firstTwoNames = nameParts.slice(0, 2);

  // Normalize names (strip accents and special chars) and join with dashes
  const namePrefix = firstTwoNames.map(name => normalizeString(name)).join('-');

  return `${namePrefix}/${today}`;
};
